
/*
* @Author: syyoon@yongtrim.com 
* @Date: 2018-09-30 20:08:09 
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2018-10-09 19:06:56
*/

import { Injectable } from "@angular/core";
// import { AlertService } from "./alert.service";
@Injectable()
export class PurchaseService {

  constructor(
    // private alertService: AlertService,
    ) { 

  }

  ready() {
    // this.iap.getProducts(['tv.celebcrush.krush.price1'])
    //   .then((products) => {
    //     // this.alertService.showToastMessage(JSON.stringify(products));
    //     //  [{ productId: 'com.yourapp.prod1', 'title': '...', description: '...', price: '...' }, ...]
    //   })
    //   .catch((err) => {
    //   });
    
    // this.iap
    //   .buy('tv.celebcrush.krush.price1')
    //   .then((data) => {
    //     console.log('data', JSON.stringify(data));
    //     // {
    //     //   transactionId: ...
    //     //   receipt: ...
    //     //   signature: ...
    //     // }
    //   })
    //   .catch((err) => {
    //     console.log('err', JSON.stringify(err));
    //   });
  }

}


// WEBPACK FOOTER //
// ./src/services/purchase.service.ts